import { MdClose } from 'react-icons/md';
import AddChargeForm from './AddChargeForm';

// Thin modal shell around AddChargeForm — reused by the Students drawer (studentId fixed) and
// the Payments page's Collect tab (student picked via the form's own StudentSelect). The form
// itself (fields + submit logic) lives in AddChargeForm.jsx, shared with the Finance → Ledger
// "Record income" modal's "For a student" tab, which embeds it directly without this shell
// (that modal already has its own header/overlay).
export default function AddChargeModal({ studentId, students = [], onClose, onCreated }) {
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 px-4"
      onClick={(e) => e.target === e.currentTarget && onClose?.()}>
      <div className="bg-card border border-divider rounded-2xl shadow-2xl w-full max-w-sm">
        <div className="flex items-center justify-between px-5 py-4 border-b border-divider">
          <h3 className="font-bold text-secondary">Add Charge</h3>
          <button type="button" onClick={onClose} className="text-muted hover:text-secondary"><MdClose size={20} /></button>
        </div>
        <AddChargeForm studentId={studentId} students={students} onClose={onClose} onCreated={onCreated} />
      </div>
    </div>
  );
}
